// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"1702":"4d34c113","7222":"18394c63","7937":"de4f6177"}[chunkId] || chunkId) + "." + {"1702":"346d22455fac4d6e","5763":"87b5e0bda0a042f0","7222":"d74402e27c9a0f93","7937":"f414b53c24a5155a"}[chunkId] + ".js";
};